<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid" *ngIf="accessService.hasAccess([], ['payments.menu'])">
  <div class="d-flex justify-content-between align-items-center">
    <h5 class="title-secondary">
      {{ 'PAYMENTS.PAYMENTS_LIST.TITLE' | translate }}
    </h5>

    <div>
      <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
        {{ 'CLEAR_FILTERS' | translate }}
      </button>

      <button
        *ngIf="
          accessService.hasAccess(
            [
              UserRoleType.RESERVATION_AGENT,
              UserRoleType.RESERVATION_MANAGER,
              UserRoleType.CONTRACTING_AGENT,
              UserRoleType.CONTRACTING_MANAGER,
              UserRoleType.FINANCE_AGENT,
              UserRoleType.FINANCE_MANAGER
            ],
            ['payments.store']
          )
        "
        type="button"
        class="btn btn-secondary btn-input"
        (click)="add()"
      >
        {{ 'PAYMENTS.PAYMENTS_LIST.ADD' | translate }}
      </button>
    </div>
  </div>

  <kendo-grid
    [data]="data"
    [pageSize]="paymentsResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'Payments', grid)"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.ID' | translate }}"
      filter="numeric"
      [width]="120"
      [hidden]="isHiddenColumn('id', true)"
      format="0"
    ></kendo-grid-column>

    <kendo-grid-column
      field="company.abbreviation"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.COMPANY' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('company.abbreviation')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-company-select [filter]="filter"></app-kendo-company-select>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.company?.shortName }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="bookingCompanies"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.BOOKING_OFFICES' | translate }}"
      [filterable]="false"
      [sortable]="false"
      [hidden]="isHiddenColumn('bookingCompanies')"
    >
    </kendo-grid-column>

    <kendo-grid-column
      field="clientable.name"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.CLIENTABLE_NAME' | translate }}"
      [filterable]="false"
      [sortable]="false"
      [hidden]="isHiddenColumn('clientable.name')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="paymentable.invoiceable.sale.event.name"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.EVENT' | translate }}"
      [filterable]="false"
      [sortable]="false"
      [hidden]="isHiddenColumn('paymentable.invoiceable.sale.event')"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.paymentable?.invoiceable?.sale?.event?.name }}
        {{ dataItem.paymentable?.invoiceable?.sale?.event?.date_from | amDateFormat : 'YYYY' }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="finalHotels"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.HOTELS' | translate }}"
      [filterable]="false"
      [sortable]="false"
      [hidden]="isHiddenColumn('finalHotels')"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div *ngFor="let hotel of dataItem.finalHotels; let i = index">
          {{ hotel }}<span *ngIf="i !== dataItem.finalHotels?.length - 1">, </span>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="bookingSuppliers"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.SUPPLIERS' | translate }}"
      [filterable]="false"
      [sortable]="false"
      [hidden]="isHiddenColumn('bookingSuppliers')"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div *ngFor="let supplier of dataItem.bookingSuppliers; let i = index">
          {{ supplier }}<span *ngIf="i !== dataItem.bookingSuppliers?.length - 1">, </span>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="bookingRefNumbers"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.REF_NUMBERS' | translate }}"
      [filterable]="false"
      [sortable]="false"
      [hidden]="isHiddenColumn('bookingRefNumbers')"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div *ngFor="let refNumber of dataItem.bookingRefNumbers; let i = index">
          {{ refNumber }}<span *ngIf="i !== dataItem.bookingRefNumbers?.length - 1">, </span>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="payment_claim"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.PAYMENT_CLAIM' | translate }}"
      [filterable]="false"
      [sortable]="false"
      [hidden]="isHiddenColumn('payment_claim')"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem.paymentable?.type"></app-type-badge>
        <small *ngIf="dataItem?.paymentable?.linked_id && dataItem?.paymentable?.type_id === InvoiceType.PROFORMA">
          {{ 'PAYMENTS.PAYMENTS_LIST.LINKED_TO_ORIGINAL' | translate }} #{{ dataItem?.paymentable?.linked_id }}
        </small>
        <small *ngIf="dataItem?.paymentable?.linked_id && dataItem?.paymentable?.type_id === InvoiceType.ORIGINAL">
          {{ 'PAYMENTS.PAYMENTS_LIST.LINKED_TO_PROFORMA' | translate }} #{{ dataItem?.paymentable?.linked_id }}
        </small>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="paymentable.number"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.INVOICE_NUMBER' | translate }}"
      [filterable]="false"
      [sortable]="false"
      [hidden]="isHiddenColumn('paymentable.number')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="cleanClientableType"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.CLIENTABLE_TYPE' | translate }}"
      [filterable]="false"
      [sortable]="false"
      [hidden]="isHiddenColumn('cleanClientableType', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="cleanPaymentableType"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.PAYMENTABLE_TYPE' | translate }}"
      [filterable]="false"
      [sortable]="false"
      [hidden]="isHiddenColumn('cleanClientableType', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="paymentable_id"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.PAYMENTABLE_ID' | translate }}"
      [filterable]="true"
      filter="numeric"
      [hidden]="isHiddenColumn('paymentable_id', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="type.value"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.TYPE' | translate }}"
      [hidden]="isHiddenColumn('type.value')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select [groupType]="'payment'" [filter]="filter"></app-kendo-type-select>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem.type"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="payment_method.value"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.PAYMENT_METHOD' | translate }}"
      [hidden]="isHiddenColumn('payment_method.value')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select [groupType]="'payment_method'" [filter]="filter" [field]="'payment_method_id'">
        </app-kendo-type-select>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem.payment_method"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="amount"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.AMOUNT' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('amount')"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div>
          {{ dataItem.amount | number : '1.2-2' }}
          <app-currency-box [currency]="dataItem?.currency"></app-currency-box>
        </div>
        <app-currency-converter [value]="dataItem.amount" [fromCurrency]="dataItem.currency"></app-currency-converter>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="bookingPaymentDeadline"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.BOOKING_PAYMENT_DEADLINE' | translate }}"
      [filterable]="false"
      [sortable]="false"
      [hidden]="isHiddenColumn('bookingPaymentDeadline')"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div *ngFor="let deadLine of dataItem.bookingPaymentDeadline; let i = index">
          {{ deadLine | amDateFormat : env.momentDateFormat
          }}<span *ngIf="i !== dataItem.bookingPaymentDeadline?.length - 1">, </span>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="fee_amount"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.FEE_AMOUNT' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('fee_amount', true)"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div>
          {{ dataItem.fee_amount | number : '1.2-2' }}
          <app-currency-box [currency]="dataItem?.fee_currency"></app-currency-box>
        </div>
        <app-currency-converter
          [value]="dataItem.fee_amount"
          [fromCurrency]="dataItem.fee_currency"
        ></app-currency-converter>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="date"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.DATE' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('date', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.date | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="refundable_id"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.REFUNDABLE' | translate }}"
      [hidden]="isHiddenColumn('refundable_id', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select [groupType]="'payment_refundable'" [filter]="filter" [field]="'refundable_id'">
        </app-kendo-type-select>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem.refundable"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="refundable_percent"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.REFUNDABLE_PERCENT' | translate }}"
      [hidden]="isHiddenColumn('refundable_percent', true)"
      filter="numeric"
    >
    </kendo-grid-column>

    <kendo-grid-column
      field="refundable_date"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.REFUNDABLE_DATE' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('refundable_date', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.refundable_date | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="is_approved"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.IS_APPROVED' | translate }}"
      filter="boolean"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('is_approved', true)"
      [width]="100"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.is_approved"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="is_paid"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.IS_PAID' | translate }}"
      filter="boolean"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('is_paid')"
      [width]="100"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.is_paid"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="has_documents"
      title="{{ 'PAYMENTS.PAYMENTS_LIST.HAS_DOCUMENTS' | translate }}"
      filter="boolean"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('has_documents', true)"
      [width]="100"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.has_documents"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'PAYMENTS.PAYMENTS_LIST.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-edit-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER
              ],
              ['payments.show']
            )
          "
          (click)="edit(dataItem)"
        >
        </app-edit-button>

        <app-activities-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER
              ],
              []
            )
          "
          [subjectType]="LaravelModels.PAYMENT"
          [subjectId]="dataItem.id"
        >
        </app-activities-button>

        <app-media-library-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER
              ],
              ['media.index']
            )
          "
          [ngbTooltip]="'PAYMENTS.PAYMENTS_LIST.UPLOAD_DOCUMENTS' | translate"
          container="body"
          [modelId]="dataItem.id"
          [modelType]="LaravelModels.PAYMENT"
          [collectionName]="'files'"
          [acceptType]="MediaLibraryAcceptTypes.ALL"
          [icon]="'fal fa-file'"
        ></app-media-library-button>

        <app-delete-button
          *ngIf="
            accessService.hasAccess([UserRoleType.FINANCE_AGENT, UserRoleType.FINANCE_MANAGER], ['payments.destroy'])
          "
          [swal]="{}"
          (confirm)="delete(dataItem)"
        >
        </app-delete-button>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
